<div class="vehicle-images">
	<div class="gallery-container">
		<!--  GALLERY  -->

		<cng-gallery [images]="vehicle.images" (imageRemoved)="removeImage($event)" *ngIf="show_gallery"></cng-gallery>

		<!--  END GALLERY  -->

		<!--  GALLERY META  -->

		<div class="gallery-meta" [ngClass]="{ centered: vehicle.images.length < 1 }">
			<div *ngIf="vehicle.registration" class="number-plate number-plate-large">
				{{ vehicle.registration }}
			</div>
			<div *ngIf="vehicle.images.length > 0" class="swiper-pagination"></div>
		</div>

		<!--  END GALLERY META  -->
	</div>
</div>
